import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './shared/guard/auth.guard';
import { hrGuard } from './shared/guard/hr.guard';
import { RedirectHandlerComponent } from './redirect-handler/redirect-handler.component';
import { UserVerificationComponent } from './user-verification/user-verification.component';
import { DOMAIN_CONFIG } from 'domain-config';

const currentDomain = window.location.hostname;
const isStaffingDomain = DOMAIN_CONFIG[currentDomain]?.isStaffingDomain === true;



const routes: Routes = [
  {
    path: 'redirect',
    component: RedirectHandlerComponent, 
  },
  {
    path: 'verification', component: UserVerificationComponent,
  },
  {
    path: '', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'main', loadChildren: () => import('./main/main.module').then(m => m.MainModule),
    canActivate:[authGuard]
  },
  {
    path: 'examination', loadChildren: () => import('./examination/examination.module').then(m => m.ExaminationModule),
    canActivate:[authGuard]
  },
  {
    path:'mobile-verification', loadChildren: () => import('./mobile-verification/mobile-verification.module').then(m => m.MobileVerificationModule),
    // canActivate:[authGuard]
  },

  {
    path: 'super-admin', loadChildren: () => import('./super-admin/super-admin.module').then(m => m.SuperAdminModule),
    // canActivate:[adminGuard]
  },

  {
    path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
    // canActivate:[adminGuard]
  },
  // {
  //   path: 'hr', loadChildren: () => import('./hr/hr.module').then(m => m.HrModule),
  //   canActivate:[hrGuard]
  // },
  {
    path: 'college-admin', loadChildren: () => import('./college-admin/college-admin.module').then(m => m.CollegeAdminModule),
    // canActivate:[collegeAdminGuard]
  },
  // {
  //   path:"full-screen",component:FullscreenComponent
  // },
  // {
  //   path:"microphone-test",component:MicrophoneTestComponent
  // },
  // {
  //   path:"screen-recorder",component:ScreenRecorderComponent
  // },
  // {
  //   path:"web-cam",component:WebCamComponent
  // }
  // { path: '**', redirectTo: '/' },
];

if (isStaffingDomain) {
  routes.push({
    path: 'staffing',
    loadChildren: () => import('./staffing/staffing.module').then(m => m.StaffingModule),
    canActivate: [hrGuard],
  });
} else {
  routes.push({
    path: 'hr',
    loadChildren: () => import('./hr/hr.module').then(m => m.HrModule),
    canActivate: [hrGuard],
  });
}

// Wildcard route should be last
routes.push({ path: '**', redirectTo: '/' });



@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'top',
    anchorScrolling: 'enabled',
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
